module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/column/rame.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/column/rame.jpg
// module id = 546
// module chunks = 0